import React from "react";
import './footer.sass';
import { FooterMap } from "./footerMap";


export const Footer= () => {
    return (
      <div id="lox">
        <div id='footerNamePortfolio'>@MR.BROCK PORTFOLIO</div>

        <div id='footerImgCenter'>
          <div className='footerImg'>
            <FooterMap />
          </div>
        </div>

        <div>© 2020</div>
      </div>
    );
  }
